<template>
    <div :class="classBuilder('RPNotificationCard')">
        <div class="RPNotificationCard__status-container">
            <StreamlineIcon
                :icon="circleIcon"
                :stroke="primary"
                :fill="circleIconFill"
                :size="12"
            />
        </div>
        <div class="RPNotificationCard__content">
            <div class="RPNotificationCard__title">
                {{ notification.title }}
                <span
                    v-if="showDate"
                    class="RPNotificationCard__date"
                >{{ dateFormatted }}</span>
                <span
                    class="RPNotificationCard__time"
                >{{ time }}</span>
            </div>
            <div :class="['RPNotificationCard__message', card && 'RPNotificationCard__message--card']">
                <div class="RPNotificationCard__message-text">
                    {{ notificationMessage }}
                </div>
            </div>
        </div>
        <div
            class="RPNotificationCard__delete"
            @click="deleteNotification"
        >
            <StreamlineIcon
                :icon="Close"
                :stroke="textGrey"
                :size="14"
            />
        </div>
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {SignBadgeCircle} from "@reviewpush/streamline-regular/lib/maps-navigation/SignShapes";
import {Close} from "@reviewpush/streamline-regular/lib/interface-essential/FormValidation";
import {CheckCircle1} from "@reviewpush/streamline-bold/lib/interface-essential/FormValidation";
import {SynchronizeArrows1} from "@reviewpush/streamline-bold/lib/interface-essential/Synchronize";
import {CloudDownload} from "@reviewpush/streamline-regular/lib/internet-networks-servers/Cloud";
import statusBuilder from 'status/statusBuilder';
import has from 'lodash/has';
import moment from 'moment';
import colors from 'style/_colors.scss';

const NotificationValidation = (val) => {
    return has(val, 'id')
        && has(val, 'title');
};

export default {
    name: 'RPNotificationCard',
    components: {
        StreamlineIcon
    },
    props: {
        card: {
            type: Boolean,
            default: true,
        },
        notification: {
            type: Object,
            required: true,
            validation: NotificationValidation,
        },
    },
    data(){
        return {
            generatingIcon: SynchronizeArrows1,
            Close,

            successIcon: CheckCircle1,
            successGreen: colors.success,

            cloudIcon: CloudDownload,
            cloudGreen: colors.success400,

            textGrey: colors.textGrey,

            circleIcon: SignBadgeCircle,
            primary: colors.primary,
        };
    },
    computed: {
        read(){
            return this.notification.attributes.read_at;
        },
        dateTime(){
            return moment(this.notification.attributes.created_at);
        },
        circleIconFill(){
            return this.read
                ? colors.white
                : colors.primary;
        },
        notificationMessage(){
            return has(this.notification.attributes, 'message')
                ? this.notification.attributes.message
                : '';
        },
        showDate(){
            return moment().diff(this.dateTime, 'days') >= 1;
        },
        dateFormatted() {
            return (moment().diff(this.dateTime, 'days') === 1)
                ? 'Yesterday'
                : this.dateTime.format('MMM D');
        },
        time() {
            return moment(this.dateTime).format('h:mm A');
        },
    },
    methods: {
        classBuilder(className){
            return statusBuilder(
                className,
                '',
                false,
                {
                    'card': this.card,
                }
            );
        },
        deleteNotification() {
            this.$emit('delete', this.notification.id);
        }
    },
};
</script>

<style lang="scss">
    .RPNotificationCard {
        padding: 1rem;
        border-radius: 4px;
        display: flex;
        align-items: center;
        height: 3.5rem;
        width: 19rem;

        &--card {
            height: auto;
            width: 100%;
            border: 1px solid transparent;
            filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.08));
            background: $white;
        }

        &__status-container {
            margin-right: 1rem;
            display: flex;
            align-items: center;
        }
        &__content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        }
        &__title {
            font-weight: 600;
        }
        &__date,
        &__time {
            color: $text-grey;
            font-size: 0.75rem;
            font-weight: normal;
        }
        &__date {
            margin-right: 0.25rem;
        }
        &__message {
            display: flex;
            align-items: center;
            color: $text-grey;
            width: 14rem;

            &--card {
                width: auto
            }
        }
        &__message-text {
            white-space: nowrap;
            text-overflow: ellipsis;
            display: block;
            overflow: hidden;
        }
        &__delete {
            cursor: pointer;
        }
    }
</style>

<docs>
    ```vue
        <RPNotificationCard :notification="{
        'type': 'notifications',
        'id': 'd25cfa41-7006-40e8-9950-776c4c545ff6',
        'attributes': {
            'type': 'App\\Notifications\\Report\\ReportFailed',
            'notifiable_type': 'App\\User',
            'notifiable_id': 3,
            'data': {
                'report_key_id': '61c04350-8244-4d29-9977-e5b5ef7519a3',
                'name': 'Collective Report'
            },
            'read_at': {
                'date': '2020-10-24 19:13:08.000000',
                'timezone_type': 3,
                'timezone': 'America/Chicago'
            },
            'created_at': '2020-10-24 19:12:08'
        }
        }"></RPNotificationCard>
    ```
</docs>
